import { Progress } from "../../components/ui/progress";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import ArrowUp from "../../assets/icons/arrow-up.png";
import ArrowDown from "../../assets/icons/arrow-down.png";

interface PerformanceItemProps {
  number: number;
  name: string;
  percentage: number;
  value: string;
  isPositive: boolean;
  completedRequests: number
}

export function PerformanceItem({
  number,
  name,
  percentage,
  value,
  isPositive,
  completedRequests
}: PerformanceItemProps) {
  return (
    <div className="flex items-center gap-2 p-4 px-2 border-transparent border-b border-solid border-b-primary shadow-lg shadow-slate-300 text-gray-400">
      <div className="flex items-center gap-3">
        <span className="text-sm font-semibold text-primary">{number}</span>
        <span className="w-32 text-nowrap overflow-hidden text-ellipsis text-xs font-semibold">{name}</span>
      </div>
      <div className="flex-1 flex items-center gap-2">
        <div className="flex-1 relative">
          <Progress value={percentage} />
          <span className="absolute font-semibold w-full block text-[10px] mt-[2px] text-center">{completedRequests} RD</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold">{percentage}%</span>
          <span
            className={`font-bold ${
              isPositive ? "text-green-500" : "text-red-500"
            }`}
          >
            {value}
          </span>
          {isPositive ? <img src={ArrowUp} alt="Arrow up" /> : <img src={ArrowDown} alt="Arrow down" /> }
        </div>
      </div>
    </div>
  );
}
